import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { getLocationById } from '../../../domain/domain'
import { ILocation, ISubLocationHierarchyName } from '../../../domain/interfaces/ILocation'
import { showConfirmationDeleteMessage } from '../../components/dialogs/confirmation-dialog/ConfirmationDialog'
import { useOrganizationProvider } from '../../../providers/OrganizationProvider'

export interface LocationPageContextType {
  getLocation: () => void
  location: ILocation | undefined
  locationLoading: boolean
  locationError: string | undefined
  showDeleteConfirmation: (ids: string[]) => void
  locationName: string
  setLocation: (location: ILocation) => void
  locationHierarchies: ISubLocationHierarchyName[]
  setLocationHierarchies: (locationHierarchies: ISubLocationHierarchyName[]) => void
}

const LocationPageContext = React.createContext<LocationPageContextType | null>(null)
LocationPageContext.displayName = 'LocationPageContext'

interface LocationPageVMProps {
  children: React.ReactNode
  locationId?: string
}
type Key = 'level1Name' | 'level2Name' | 'level3Name' | 'level4Name' | 'level5Name'
export const locationKeys: Key[] = ['level1Name', 'level2Name', 'level3Name', 'level4Name', 'level5Name']

export const LocationPageViewModel: React.FC<LocationPageVMProps> = ({ children, locationId }) => {
  const { id } = useParams()
  const { getHierarchyName } = useOrganizationProvider()

  const [locationHierarchies, setLocationHierarchies] = useState<ISubLocationHierarchyName[]>([])

  //STATE
  const [location, setLocation] = useState<ILocation | undefined>(undefined)
  const [locationLoading, setLocationLoading] = useState<boolean>(true)
  const [locationError, setLocationError] = useState<string | undefined>()

  // Matches levels delete logic
  const handleDelete = async () => {
    // const res = await deleteLoation(location!.id)
    // if (res.isLeft()) {
    //   ErrorToast({ title: `Failed to delete ${location!.name}.` })
    //   return
    // }
    // SuccessToast({ title: `${location!.name} successfully deleted.` })
    // navigate(-1)
  }

  const showDeleteConfirmation = async () => {
    showConfirmationDeleteMessage(getLocationName(), handleDelete)
  }

  const getLocationName = () => {
    if (!location) return ''
    return location.name
  }

  const getLocation = async () => {
    setLocationError(undefined)
    setLocationLoading(true)
    const lId = locationId ? locationId : id
    const res = await getLocationById(lId ?? 'none')
    setLocationLoading(false)
    if (res.isLeft()) {
      setLocationError(`Error loading ${getHierarchyName(-1)}`)
    }
    setLocation(res.right as ILocation)
    setLocationHierarchies(
      locationKeys.map((key, index) => {
        return {
          id: index + '',
          name: res.right?.[key] ?? '',
          level: index + 1,
        }
      }),
    )
  }

  useEffect(() => {
    if (!locationId && !id) return
    getLocation()
  }, [])

  return (
    <LocationPageContext.Provider
      value={{
        location,
        locationLoading,
        locationError,
        locationName: getLocationName(),
        getLocation,
        showDeleteConfirmation,
        setLocation,
        locationHierarchies,
        setLocationHierarchies,
      }}
    >
      {children}
    </LocationPageContext.Provider>
  )
}
export default LocationPageContext

export function useLocationPageViewModel() {
  const context = useContext(LocationPageContext)
  if (!context) {
    throw new Error('useLocationPageViewModel must be used within a LocationPageViewModel')
  }
  return context
}
